import React from 'react';
import { IArticle } from '../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const markirovka_reklami_v_telegram: IArticle = {
  title: 'Маркировка рекламы в Телеграм: пошаговая инструкция',
  image: '/assets/img/blog/markirovka_reklami_v_telegram.jpeg',
  prewievImage: '/assets/img/blog/markirovka_reklami_v_telegram-prewiev.jpeg',
  content: [
    {
      text: [
        'Согласно поправкам к Закону о рекламе № 347-ФЗ от 1 сентября 2022 года, все рекламные публикации (посты) в Телеграм должны быть промаркированы. К рекламным публикациям относятся: рекламные статьи у блогеров и в публичных каналах, а также объявления, размещаемые через Telegram Ads. Далее, мы пошагово разберём, как маркируется реклама на данной платформе.',
      ],
    },
    {
      subTitle: 'Любая маркировка начинается с ОРД',
      text: [
        'Получить рекламный маркер и в дальнейшем отчитаться о составе рекламной кампании можно у оператора рекламных данных (ОРД).',
        <>
          Чтобы стать клиентом ОРД от SberAds, прежде всего, необходимо
          зарегистрироваться на <a href="/">сайте</a>, предоставить требуемые
          документы и принять оферту. После этого внести данные об участниках
          рекламной цепочки и самом креативе в Личном кабинете ОРД. Подробнее о
          процессе маркировки и регистрации в ОРД мы рассказали в статье{' '}
          <a href="/blog/chto_takoe_operator_reklamnih_dannih">
            «Что такое оператор рекламных данных и как маркировать рекламу в
            ОРД»
          </a>
          .
        </>,
        'ОРД (оператор рекламных данных) – площадка, которая выступает посредником между участниками рекламного рынка – Рекламодателем (РД), Рекламным агентством (РА), Рекламораспространителем (РР), Оператором рекламных систем (ОРС) и ЕРИР (Роскомнадзор). ОРД агрегирует информацию о рекламных кампаниях и их участниках, включая данные о показах, просмотрах и кликах, автоматически все данные передаются в ЕРИР (Единый реестр интернет-рекламы, специальная система Роскомнадзора, которая ведёт учёт всей рекламной интернет активности в Рунете).',
        'В рамках работы с ОРД участник рекламного рынка при регистрации креатива (данные о рекламной публикации) получает токен/маркер (erid) — уникальный рекламный идентификатор, который по Закону должен быть размещён в рекламной публикации.',
      ],
    },
    {
      subTitle: 'Где размещать рекламный маркер (erid)?',
      text: [
        'Согласно Закону все рекламные публикации должна сопровождать следующая информация:',
        <ul>
          <li>Слово «Реклама» </li>
          <li>
            Наименование рекламодателя и/или ссылки на сайт/страницу в сети
            Интернет с наименованием рекламодателя
          </li>
          <li>Идентификатор (erid: xxxxx).</li>
        </ul>,
        'Например: Реклама. ООО «Весна». erid: xxxxx',
        <strong>
          Рекламный идентификатор (erid) в публикации можно разместить
          несколькими способами:
        </strong>,
        <ul>
          <li>
            В кликабельной ссылке, ведущей на рекламируемую страницу, лэндинг,
            сайт. <br />
            Основной способ добавления erid в ссылки - это добавление
            GET-параметра к кликовой ссылке до редиректа, в виде:
            <i>https://www.site.ru/?erid=xxxxxx</i> <br />
            Если ссылка уже содержит какие-либо GET-параметры, то erid
            добавляется либо сразу после знака «?», либо через «&» в списке
            GET-параметров, например: <br />
            <i>
              https://www.site.ru/?erid=xxxxxx&utm_source=telegram&utm_medium=cpc&utm_campaign=campaign&utm_content=xxxxxx
            </i>
            <br />
            <i>
              https://www.site.ru/?utm_source=telegram&utm_medium=cpc&erid=xxxxxxx&utm_campaign=campaign&utm_content=xxxxxx
            </i>
            <br />
            <i>
              https://www.site.ru/?utm_source=telegram&utm_medium=cpc&utm_campaign=campaign&utm_content=xxxxxxx&erid=xxxxxxx
            </i>
            <br />
          </li>
          <li>В текстовом формате erid: xxxxxxxx.</li>
          <li>На изображении, обычно в нижней его части.</li>
          <li>
            В начале или в конце видео, либо текстом поверх видео изображения
            (erid: xxxxxxxx).
          </li>
        </ul>,
        <>
          Подробно о маркировке различных рекламных форматов мы рассказали в
          статье:{' '}
          <a href="/blog/poryadok_razmeshenia_markera_v_reklame">
            «Порядок размещения маркера (erid:xxxxx) в рекламе с примерами»
          </a>
          .
        </>,
      ],
    },
    {
      subTitle: 'Требования к передаче статистики и отчётности в ОРД',
      text: [
        'По итогу месяца размещения рекламы, необходимо в течение 30 дней с момента окончания срока размещения публикации, передать отчётность по рекламе в ЕРИР через Личный кабинет ОРД. В состав передаваемого отчёта входит информация об участниках рекламной кампании, договорах, актах, креативах, кликах и о количестве показов.',
        'Важно учитывать, что, если реклама размещается на протяжении нескольких месяцев, то каждый месяц необходимо подавать отчёт по данной рекламной публикации (креативу).',
        <>
          Понятие «Креатив» включает в себя форму любой рекламной публикации или
          сообщения. Это может быть только текст, текст с изображением, текст с
          видео и т.д. Подробно о возможных формах креатива можно прочитать в
          Документации на <a href="/documentation/9#54">сайте</a>.
        </>,
        'Например:',
        <ul>
          <li>
            Креатив был показан с 15 по 20 октября. В этом случае, отчёт по
            креативу нужно предоставить в течение ноября, но не позднее 30
            ноября;
          </li>
          <li>
            Креатив был показан на стыке двух месяцев – с 15 октября по 15
            ноября. В этом случае отчёт о количестве показов нужно предоставить
            в два этапа:
          </li>
          <li>
            рекламное размещение с 15 октября по 31 октября, предоставить отчёт
            до 30 ноября
          </li>
          <li>
            рекламное размещение с 1 ноября по 15 ноября, предоставить отчёт до
            30 декабря
          </li>
        </ul>,
        'Ответственного за передачу данных (за маркировку рекламы) определяют сами участники рекламной кампании и прописывают данный пункт в соглашении или в договоре. Ответственным за маркировку может быть сам рекламодатель, рекламораспространитель, рекламное агентство, либо третье лицо.',
        <>
          Важно помнить, что ответственность за несоблюдение правил маркировки
          несут все участники рекламной цепочки, поэтому важно контролировать
          факт передачи данных и отчётности в ОРД. Подробнее об ответственности
          и штрафах при несоблюдении Закона о маркировке можно почитать{' '}
          <a href="/blog/otvetstvennost_za_shtrafi">здесь</a>.
        </>,
      ],
    },
    {
      subTitle: 'Реклама в Telegram Ads',
      text: [
        'Telegram Ads - это отдельный рекламный формат, который содержит сжатое рекламное сообщение и размещается в специальном блоке под последним постом в публичном Телеграм канале. Такие рекламные блоки также должны быть промаркированы. Для этого полученный маркер (erid) указывается в личном кабинете Telegram Ads и добавляется в ссылку.',
      ],
    },
    {
      subTitle: 'Особенности маркировки в Телеграм',
      text: [
        'В целом маркировка в Телеграм ничем не отличается от общего процесса маркировки на любой другой площадке и попадает под единые требования Закона.',
      ],
    },
    {
      subTitle:
        'Напомним, ещё раз об основных тезисах Закона о маркировке рекламы в интернете:',
      text: [
        'С 1 сентября 2022 года, согласно поправкам к Закону о рекламе № 347-ФЗ, вся реклама в интернете подлежит маркировке, регистрации в ОРД и последующей отчетности в ЕРИР. По требованиям Закона рекламодатель обязан получать специальные идентификаторы (erid: xxxxxx) у оператора рекламных данных (ОРД) для каждого рекламного креатива, а затем каждый месяц направлять отчеты о показах в Единый реестр интернет-рекламы (ЕРИР).',
        'Маркер (erid) не привязан к определённой рекламной платформе, поэтому может быть получен в любом ОРД. Если вы получили маркер в ОРД от SberAds, то в личном кабинете при регистрации креатива вам необходимо указать площадки, на которых вы планируете показы рекламы, в том числе площадку Telegram.',
        'После того как рекламные показы закончатся, в течение 30 дней передать в ЕРИР (через Личный кабинет ОРД) информацию количестве показов.',
        <>
          Если у вас остались вопросы, вы всегда можете их задать, написав в
          службу клиентской поддержки{' '}
          <a href="mailto:info@ord-lab.ru" target="_blank" rel="noreferrer">
            info@ord-lab.ru
          </a>
          .
        </>,
      ],
    },
  ],
};

export default markirovka_reklami_v_telegram;
